/* 🤖 this file was generated by svg-to-ts */
export const siriusPlayCircle: {
  name: 'play_circle';
  data: string;
} = {
  name: 'play_circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.916 8.376A.75.75 0 0 0 9.75 9v6a.75.75 0 0 0 1.166.624l4.5-3a.75.75 0 0 0 0-1.248l-4.5-3Zm.334 5.223V10.4L13.648 12l-2.398 1.599Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Z" fill="currentColor"/></svg>`
};
